import { Phone, Mail, MapPin, Instagram, ArrowUp } from "lucide-react";
import { Button } from "@/components/ui/button";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const quickLinks = [
    { name: "Home", href: "#home" },
    { name: "About", href: "#about" },
    { name: "Services", href: "#services" },
    { name: "Testimonials", href: "#testimonials" },
    { name: "Contact", href: "#contact" },
  ];

  const services = [
    "Vedic Astrology",
    "Numerology",
    "Kundali Matching",
    "Vastu Shastra",
    "Palm Reading",
    "Face Reading",
  ];

  return (
    <footer className="bg-brown-deep border-t border-border relative">
      {/* Back to Top */}
      <Button
        onClick={scrollToTop}
        size="icon"
        className="absolute -top-6 left-1/2 -translate-x-1/2 rounded-full bg-primary text-primary-foreground hover:bg-primary/90 shadow-gold"
      >
        <ArrowUp className="w-5 h-5" />
      </Button>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="relative w-10 h-10 flex items-center justify-center">
                <svg
                  viewBox="0 0 50 50"
                  className="w-full h-full"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="25"
                    cy="25"
                    r="23"
                    stroke="hsl(var(--gold))"
                    strokeWidth="2"
                  />
                  <circle cx="25" cy="25" r="4" fill="hsl(var(--gold))" />
                  <path
                    d="M25 6 L25 15 M25 35 L25 44 M6 25 L15 25 M35 25 L44 25"
                    stroke="hsl(var(--gold))"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
              <div>
                <span className="font-display text-lg font-semibold text-gradient-gold">
                  Tapask
                </span>
                <span className="block text-xs text-muted-foreground">
                  Astrologer
                </span>
              </div>
            </div>
            <p className="text-muted-foreground text-sm leading-relaxed mb-6">
              Your trusted guide to spiritual enlightenment and divine solutions 
              through the ancient wisdom of Vedic astrology.
            </p>
            <a
              href="https://www.instagram.com/tapaskastrologer/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-primary hover:text-primary/80 transition-colors"
            >
              <Instagram className="w-5 h-5" />
              <span className="text-sm">@tapaskastrologer</span>
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-display text-lg font-semibold text-foreground mb-6">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-muted-foreground hover:text-primary transition-colors text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-display text-lg font-semibold text-foreground mb-6">
              Our Services
            </h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service}>
                  <a
                    href="#services"
                    className="text-muted-foreground hover:text-primary transition-colors text-sm"
                  >
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display text-lg font-semibold text-foreground mb-6">
              Contact Info
            </h4>
            <div className="space-y-4">
              <a
                href="tel:+919870511379"
                className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors text-sm"
              >
                <Phone className="w-4 h-4 flex-shrink-0" />
                +91 98705 11379
              </a>
              <a
                href="mailto:tapaskastrologernumerologist@gmail.com"
                className="flex items-start gap-3 text-muted-foreground hover:text-primary transition-colors text-sm"
              >
                <Mail className="w-4 h-4 flex-shrink-0 mt-0.5" />
                <span className="break-all">tapaskastrologernumerologist@gmail.com</span>
              </a>
              <div className="flex items-start gap-3 text-muted-foreground text-sm">
                <MapPin className="w-4 h-4 flex-shrink-0 mt-0.5" />
                <span>B-302, Telecom City, Sector 62, Noida 201301</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-border">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-muted-foreground text-center sm:text-left">
              © {new Date().getFullYear()} Tapask Astrologer. All rights reserved.
            </p>
            <p className="text-sm text-muted-foreground">
              Pandit Tapas Dutta - Best Astrologer in Noida
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
